import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue"

import { WalletProvider } from '@solana/wallet-adapter-vue';
import {
  getBitKeepWallet,
  getBitpieWallet,
  getBloctoWallet,
  getCloverWallet,
  getCoin98Wallet,
  getLedgerWallet,
  getMathWallet,
  getPhantomWallet,
  getSafePalWallet,
  getSolflareWallet,
  getSolflareWebWallet,
  getSolletExtensionWallet,
  getSolletWallet,
  getSolongWallet,
} from '@solana/wallet-adapter-wallets';
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from './state';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();
const router = useRouter();
const transition = ref('');

router.beforeEach((to, from, next) => {
  transition.value =
    (to.meta.transitionName as string) ||
    (from.meta.transitionName as string) ||
    'fade';

  next();
});

const wallets = computed(() => [
  getPhantomWallet(),
  getSolflareWallet(),
  getSolflareWebWallet(),
  getSolletWallet(),
  getSolletExtensionWallet(),
  getBitKeepWallet(),
  getBitpieWallet(),
  getBloctoWallet(),
  getCloverWallet(),
  getCoin98Wallet(),
  getLedgerWallet(),
  getMathWallet(),
  getSafePalWallet(),
  getSolongWallet(),
]);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_unref(WalletProvider), {
    wallets: _unref(wallets),
    "auto-connect": ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component }) => [
          _createVNode(_Transition, {
            name: transition.value,
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              _createElementVNode("main", null, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
              ])
            ]),
            _: 2
          }, 1032, ["name"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["wallets"]))
}
}

})